import { JWT_KEY } from '../constants';

export const getJWTFromLocalStorage = () => {
  const prosperJWT = window.localStorage.getItem(JWT_KEY);
  return prosperJWT;
};

export const setJWTInLocalStorage = (jwt: string): void => {
  window.localStorage.setItem(JWT_KEY, jwt);
};

export const removeJWTFromLocalStorage = (): void => {
  window.localStorage.removeItem(JWT_KEY);
};
